<template>
  <div class="body" :style="'max-height:' + pageHeight + 'px;max-width:' + pageWidth + 'px;overflow: y;'">
    <el-row>
      <el-col :span="18">
        <div class="erp-left" :style="'height:' + leftHeight + 'px;overflow: y;'">
          <ListSearchToobar v-bind="searchToobarData" @search="init" v-model="searchRquest" />
          <div class="erp_list" :style="'height:'+ (leftHeight - 44) + 'px;'">
            <ul style="margin-bottom: 60px;">
              <li v-for="(item, index) in erpListData" :key="index" @click="erpListClick(item,index)" :class="active == index ? 'isActive' : ''">
                <div>
                  <span class="erp-name">{{item.name}}</span>
                  <span :class="item.active ? 'stausGreen' : 'statusGrey'"></span>
                </div>
                <!-- <div class="erp-code">{{item.id}}</div> -->
                <div style="margin-bottom: 64px;margin-top: 10px;height: 40px;">
                  <span v-if="item.url">{{item.url}}</span>
                  <span v-if="!item.url">{{$t('noFoundurl1')}}</span><br/>
                  <span>{{$t('company') + '\xa0\xa0' + item.groupName}}</span>
                </div>
                <!-- <div>
                  <span>{{$t('initial_info')}}</span><br/>
                  <span>0001（{{$t('username')}}）</span><br/>
                  <span>iceqerp2021（{{$t('password')}}）</span>
                </div> -->
                <div>
                  <span>{{$t('exp_date')}} : {{item.deadline.split(' ')[0]}}</span>
                </div>
                <div>
                  <span>{{$t('number_of_users')}} : {{item.maxUserNumber}}</span>
                  <span class="icon" style="float:right;cursor: auto"><i class="icon-color hover-none common-icon icon-visit"></i></span>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="erp-right" :style="'min-height:' + pageHeight + 'px;'">
          <ul>
            <li>
              <div class="item-name">{{itemErpList.name}}</div>
            </li>
            <li>
              <span class="item-url">{{$t('URL')}}</span>
              <!-- <span class="item-val-url" @click="onVisit" style="cursor:pointer" v-if="itemErpList.url">{{itemErpList.url}}</span> -->
              <a :href="itemErpList.url" class="item-val-url" v-if="itemErpList.url">{{itemErpList.url}}</a>
              <span class="item-val" v-else>{{$t('noFoundurl1')}}</span>
            </li>
            <li>
              <span class="item-code">{{$t('company')}}</span>
              <span class="item-val">{{itemErpList.groupName}}</span>
            </li>
            <li>
              <span class="item-code">{{$t('cellphone')}}</span>
              <span class="item-val">{{itemErpList.telephone}}</span>
            </li>
            <li style="border: none">
              <span class="item-code">{{$t('email')}}</span>
              <span class="item-val">{{itemErpList.email}}</span>
            </li>
            <div class="line-10"></div>
            <li>
              <span class="item-code">{{$t('active_date')}}</span>
              <span class="item-val">{{(itemErpList.createdTime || '').split(' ')[0]}}</span>
            </li>
            <li>
              <span class="item-code">{{$t('expire_date')}}</span>
              <span class="item-val">{{(itemErpList.deadline || '').split(' ')[0]}}</span>
            </li>
            <li>
              <span class="item-code">{{$t('user_qty')}}</span>
              <span class="item-val">{{itemErpList.maxUserNumber}}</span>
            </li>
            <li>
              <span class="item-code">{{$t('erp_status')}}</span>
              <span class="item-val" :class="itemErpList.active ? 'stausGreen' : 'statusGrey'"></span>
            </li>
          </ul>
        </div>
      </el-col>
    </el-row>
    <Footerbar>
      <TotalNum v-bind="totalOptions" :showData="erpListData.length" :totalData="totalNumber" slot="right" />
    </Footerbar>
  </div>
</template>
<script>
import erpApi from '@/apis/erp';
import TotalNum from '@/components/TotalNum';
import ListSearchToobar from '@/components/ListSearchToobar';
import Footerbar from '@/components/Footerbar';
export default {
  name: 'ErpList',
  data() {
    return {
      screenWidth: 0,
      screenHeight: 0,
      pageHeight: 0,
      pageWidth: 0,
      leftHeight: 0,
      homePageHeight: 0,
      homePageWidth: 0,
      searchToobarData: {
        showBarRight: true,
        floatRight: true,
        formArray: [
          // {
          //   label: 'Group Name',
          //   type: 'input',
          //   model: 'name',
          //   width: false
          // },
          {
            label: this.$t('company'),
            type: 'input',
            model: 'groupName',
            width: true
          }
          // {
          //   label: 'Group Code',
          //   type: 'input',
          //   model: 'id',
          //   width: false
          // }
        ],
        componentName: this.$t('erp_list')
      },
      erpListInformation: [
        {
          label: 'VORPCO GROUP',
          value: ''
        },
        {
          label: 'Group Code',
          value: ''
        }
      ],

      itemErpList: {},
      searchRquest: {
        groupName: ''
      },

      erpListData: [],
      appModuleList: [],
      active: 0,
      totalNumber: 0,
      totalOptions: {
        flag: true,
        whiteTheme: true,
        type: 'Erp'
      }
    };
  },

  watch: {
    screenWidth: {
      immediate: true,
      handler: function (newVal) {
        console.log(newVal);
        setTimeout(() => {
          this.calculationSize();
        }, 100);
      }
    },
    screenHeight: {
      immediate: true,
      handler: function (newVal) {
        console.log(newVal);
        setTimeout(() => {
          this.calculationSize();
        }, 100);
      }
    },
    activeName: {
      immediate: true,
      handler: function (newVal) {
        console.log(newVal);
        setTimeout(() => {
          this.calculationSize();
        }, 100);
      }
    }
  },

  computed: {
    htmlHeight() {
      const WindowHeight = window.innerHeight - 140 + 'px';
      return WindowHeight;
    },

    listHeight() {
      const WindowHeight = window.innerHeight - 194 + 'px';
      return WindowHeight;
    }
  },

  mounted() {
    this.init();
    this.calculationSize();
    const that = this;
    window.onresize = () => {
      // window.addEventListener('resize', function() {
      return (() => {
        window.screenWidth = window.innerWidth;
        that.screenWidth = window.screenWidth;
        window.screenHeight = window.innerHeight;
        that.screenHeight = window.screenHeight;
      })();
      // });
    };
  },

  methods: {
    calculationSize() {
      const windowHeight = window.innerHeight;
      const navBarHeight = 80;
      const footerBarHeight = 60;
      this.pageHeight = windowHeight - navBarHeight - footerBarHeight;
      this.leftHeight = windowHeight - navBarHeight - footerBarHeight - 10;
      const windowWidth = window.innerWidth;
      this.pageWidth = windowWidth;
    },

    async init() {
      const req = {};
      const res = await erpApi.adminErpCount(req);
      this.totalNumber = res.totalNumber;
      this.getErpList();
      this.active = 0;
    },

    erpListClick(item, index) {
      this.itemErpList = { ...item };
      console.log('this.itemErpList', this.itemErpList);
      this.active = index;
    },

    async getErpList() {
      const req = {
        filter: {
          ...this.searchRquest
        }
      };
      const res = await erpApi.adminErpList(req);
      if (res.list.length === 0) {
        return false;
      } else {
        this.erpListData = res.list;
        this.itemErpList = res.list[0];
      }
      this.active = 0;
    }
  },

  components: {
    ListSearchToobar,
    Footerbar,
    TotalNum
  }
};
</script>

<style lang="scss" scoped>
@import 'iceqerp-common/style/basic-theme-data.scss';
* {
  margin: 0;
  padding: 0;
  list-style: none;
}

.erp_list {
  padding: 0 20px;
  overflow-y: auto;
  width: 100%;
  background-color: #f4f4f4;
  ul {
    text-align: left;
  }
  li {
    width: 440px;
    height: 230px;
    display: inline-block;
    background-color: #fff;
    margin-left: 20px;
    margin-top: 45px;
    padding: 30px;
    border-radius: 4px;
  }
}

.erp-right {
  background-color: #fff;
  ul {
    padding: 35px 20px 95px 40px;
    list-style: none;
    width: 100%;
  }
  li {
    border-bottom: 1px solid #f4f4f4;
    text-align: left;
    margin: 10px 0 6px;
  }
}

.stausGreen {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: #84ce97;
  float: right;
}

.statusGrey {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: #c7c8c9;
  float: right;
}

.erp-name {
  font-weight: bold;
  font-size: 18px;
  text-align: left;
}

.isActive {
  border: 1px solid #0a0aff;
}

.item-name {
  color: $themeBlue;
  font-weight: bold;
  font-size: 24px;
}

.item-code {
  color: #292929;
  font-weight: bold;
  font-size: 14px;
}

.item-url {
  color: #292929;
  font-weight: bold;
  font-size: 14px;
}


.item-val-url {
  color: #0a0aff;
  font-size: 14px;
  float: right;
}

.item-val {
  color: #666666;
  font-size: 14px;
  float: right;
}

.item-module {
  color: #292929;
  font-size: 14px;
}

.line-10 {
  width: 100%;
  height: 10px;
  background-color: #f4f4f4;
}

.erp-code {
  // margin-bottom: 64px;
  // margin-top: 10px;
  font-size: 16px;
  color: #666666;
}

.hover-none:hover {
  color: #292929 !important;
}

.body {
height: 100%;
overflow: hidden;
min-width: 1366px;
}
</style>